// extracted by mini-css-extract-plugin
export default {"component":"DarkButtonComponent_component__oHH9p"};